import React from "react";
import PropTypes from "prop-types";
const SmilePlusIcon = ({
  width,
  size,
  height,
  style,
  color,
  noPointer,
  title,
  ...props
}) => (
  <svg
    {...props}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 23 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
    stroke={color || "var(--color-easil-gray-x-dark)"}
    data-testid="SmilePlusIcon"
  >
    <title>{title}</title>
    <g fillRule="evenodd">
      {/* <path d="M1 0h20v20H1z" /> */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5.46 13.6a3 3 0 0 0 5.1-.05"
        fill="none"
      />
      <g stroke="none" transform="translate(15)">
        <rect width="2" height="8" x="3" rx="1" />
        <rect width="8" height="2" y="3" rx="1" />
      </g>
      <circle cx="6" cy="10" r="1" stroke="none" />
      <circle cx="10" cy="10" r="1" stroke="none" />
      <circle cx="8" cy="12" r="7" fill="none" strokeWidth="2" />
    </g>
  </svg>
);
SmilePlusIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default SmilePlusIcon;
